import type { VoteChildren } from "@/appInterface/windows/VoteWindow/VoteResults/types";

export const getSortedChildren = (children: Record<string, VoteChildren>): VoteChildren[] => {
    return Object.values(children).sort((a, b) => b.votes.length - a.votes.length);
};

export const getPercent = (votesCount: number, totalCount: number): number => {
    if (totalCount === 0) return 0;

    const percent = (votesCount / totalCount) * 100;

    return Math.round(percent * 100) / 100;
};
